/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

UserHome = {
    userID: 0,
    dataBgID: 1,
    dataIndex: 1,
    editing: false,
    saved: true,
    idLastSticker: 0,
    idLastWidget: 0,
    store: {
        inv: {
            cat: function(id) {
                $("#inv-placeholder").remove();
                $("#hmUser-store .box-item").removeClass('active');
                $(".inv-cat").hide();
                $("#inv-desc").html('');

                var current = $("#inv-cat-" + id);

                current.find('.box-item').each(function() {
                    var idAttr = $(this).attr('id');
                    var infos = idAttr.split('-');
                    var id = parseInt(infos[2]);

                    if ($("#sticker-" + id).length || $("#widget-" + id).length) {
                        $(this).addClass('inactive').removeAttr('onclick');
                    }
                });

                current.show();
            },
            show: function(id, tipo) {
                item = $("#hmUser-store #box-item-" + id + "." + tipo);

                $("#inv-items .box-item").removeClass('active');
                item.addClass('active');

                nome = item.find('.nome').html();
                img = item.find('.img').css('background-image');
                img = img.replace(/['"]+/g, '');

                html = '<div class="text-info">' + nome + '</div>';

                if (item.hasClass('bg')) {
                    html += '<div class="item-img repeat"><div class="img" style="background-image: ' + img + ';"></div></div>';
                    html += '<center><button class="btn-eight" onclick="UserHome.store.inv.changeBg(' + id + ');">Usar fundo</button></center>';
                } else {
                    html += '<div class="item-img"><div class="img" style="background-image: ' + img + ';"></div></div>';
                    html += '<center><button class="btn-eight" onclick="UserHome.store.inv.insert(' + id + ', \'' + tipo + '\');">Inserir</button></center>';
                }

                $("#inv-desc").html(html);
            },
            insert: function(id, tipo) {
                item = $("#hmUser-store #box-item-" + id + "." + tipo);
                var added = false;

                if (tipo == 'sticker') {
                    //id_item_usuario = UserHome.idLastSticker + 1;

                    idAttr = item.attr('id');
                    infos = idAttr.split('-');
                    id_item_usuario = infos[2];

                    idItem = item.attr('rel');

                    if (!$('#sticker-' + id_item_usuario).length) {
                        added = true;

                        img = item.find('.img').css('background-image').slice(4).slice(0, -1);
                        img = img.replace(/['"]+/g, '');

                        image = new Image();
                        image.src = img;
                        width = image.width;
                        height = image.height;

                        pIndex = UserHome.dataIndex + 1;

                        pTop = 10;
                        pLeft = 10;


                        if (idItem == 2094) {
                            html = '<div id="sticker-' + id_item_usuario + '" rel="' + idItem + '" class="user-home-item item sticker theme-default" style="top:' + pTop + 'px;left:' + pLeft + 'px;z-index:' + pIndex + ';">';
                            html += '<div class="edit not-move">';
                            html += '<div class="settings" title="Opções" onclick="UserHome.items.options(' + id_item_usuario + ', \'sticker\');"><i class="fas fa-cog"></i></div>';
                            html += '<div class="remove" title="Remover item" onclick="UserHome.items.remove(' + id_item_usuario + ', \'sticker\');"><i class="fas fa-times"></i></div>';

                            html += '<div class="settings-box" style="width:206px;">';
                            html += '<div class="box-theme th-default active" title="Caixa de ouro" onclick="UserHome.items.setTheme(' + id_item_usuario + ', \'default\', true)"></div>';
                            html += '<div class="box-theme th-board" title="Quadro de pixels" onclick="UserHome.items.setTheme(' + id_item_usuario + ', \'board\', true)"></div>';
                            html += '<div class="box-theme th-box" title="Caixa metálica" onclick="UserHome.items.setTheme(' + id_item_usuario + ', \'box\', true)"></div>';
                            html += '<div class="box-theme th-machine" title="Máquina" onclick="UserHome.items.setTheme(' + id_item_usuario + ', \'machine\', true)"></div>';
                            html += '<div class="box-theme th-paper" title="Caderno" onclick="UserHome.items.setTheme(' + id_item_usuario + ', \'paper\', true)"></div>';
                            html += '<div class="box-theme th-shine" title="Brilhante" onclick="UserHome.items.setTheme(' + id_item_usuario + ', \'shine\', true)"></div>';
                            html += '<div class="box-theme th-speech" title="Balão de fala" onclick="UserHome.items.setTheme(' + id_item_usuario + ', \'speech\', true)"></div>';
                            html += '<div class="box-theme th-invisible_black" title="Invisível (cor preta)" onclick="UserHome.items.setTheme(' + id_item_usuario + ', \'invisible_black\', true)"></div>';
                            html += '<div class="box-theme th-invisible_white" title="Invisível (cor branca)" onclick="UserHome.items.setTheme(' + id_item_usuario + ', \'invisible_white\', true)"></div>';
                            html += '</div>';

                            html += '</div>';
                            html += '<div class="home-note-move"></div>';

                            html += '<div class="top">';
                            html += '<div class="title"></div>';
                            html += '</div>';

                            html += '<div class="middle">';
                            html += '<div class="widget-content">';
                            html += '<textarea class="home-note-textarea not-move" placeholder="Escreva sua nota aqui"></textarea>';
                            html += '</div>';
                            html += '</div>';

                            html += '<div class="bottom"></div>';

                            html += '</div>';
                        } else {
                            html = '<div id="sticker-' + id_item_usuario + '" rel="' + idItem + '" class="user-home-item item sticker" style="background-image:url(' + img + ');top:' + pTop + 'px;left:' + pLeft + 'px;z-index:' + pIndex + ';width:' + width + 'px;height:' + height + 'px;">';
                            html += '<div class="edit not-move">';
                            html += '<div class="settings" title="Inverter horizontalmente" onclick="UserHome.items.invert.x(' + id_item_usuario + ', \'sticker\');"><i class="fas fa-chevron-right"></i></div>';
                            html += '<div class="remove" title="Remover item" onclick="UserHome.items.remove(' + id_item_usuario + ', \'sticker\');"><i class="fas fa-times"></i></div>';
                            html += '</div>';
                            html += '</div>';
                        }

                        $("#user-home").prepend(html);
                        UserHome.drag();
                    }
                }

                if (tipo == 'widget') {
                    id_item_usuario = UserHome.idLastWidget + 1;

                    if (!$('#widget-' + id_item_usuario).length) {
                        added = true;
                        index = UserHome.dataIndex + 1;

                        top = 10;
                        left = 10;

                        $.ajax({
                            url: '/a/user/home/store/loadWidget',
                            type: 'POST',
                            dataType: 'json',
                            data: {
                                'id': id,
                                'id_item_usuario': id_item_usuario
                            },
                        }).done(function(data) {
                            $("#user-home").prepend(data.html);

                            UserHome.drag();
                            UserHome.widStart();
                        });
                    }
                }

                if (added) {
                    item.addClass('inactive').removeClass('active').removeAttr('onclick');
                    $("#inv-desc").html('');
                }
            },
            changeBg: function(id) {
                tipo = 'bg';
                item = $("#hmUser-store #box-item-" + id + "." + tipo);

                img = item.find('.img').css('background-image');
                img = img.replace(/['"]+/g, '');

                $("#user-home").css('background-image', img);

                $("#hmUser-store #box-item-" + UserHome.dataBgID + "." + tipo).removeClass('inactive').attr('onclick', 'UserHome.store.inv.show(' + UserHome.dataBgID + ', \'bg\');');
                UserHome.dataBgID = id;

                item.addClass('inactive').removeClass('active').removeAttr('onclick');
            }
        },
        shop: {
            cat: function(id) {
                $("#hmUser-store .box-item").removeClass('active');

                // stickers
                if (id == 1) {
                    sub = $("#sub-cat-" + id);

                    if (sub.css('display') == 'none') {
                        sub.fadeIn();
                    } else {
                        sub.fadeOut();
                    }
                }

                // backgrounds
                if (id == 2) {
                    $("#store-placeholder").remove();
                    $("#store-load-items").animate({
                        'opacity': 0.5
                    }, 'fast');

                    $.ajax({
                        url: '/a/user/home/store/shop/loadBackgrounds',
                        type: 'POST',
                        dataType: 'json'
                    }).done(function(data) {
                        $("#store-load-items").animate({
                            'opacity': 1
                        }, 'fast').html(data.html);
                    });
                }
            },
            subCat: function(id_cat, id) {
                $("#store-placeholder").remove();
                $("#store-load-items").animate({
                    'opacity': 0.5
                }, 'fast');

                $.ajax({
                    url: '/a/user/home/store/shop/loadStickersByCategory',
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        'id_cat': id
                    },
                }).done(function(data) {
                    $("#store-load-items").animate({
                        'opacity': 1
                    }, 'fast').html(data.html);
                });
            },
            show: function(id, el) {
                UserHome.store.shop.pIdsCurrent = 0;
                UserHome.store.shop.pEsmCurrent = 0;
                UserHome.store.shop.pAltCurrent = 0;

                item = $(el);

                $("#hmUser-store .box-item").removeClass('active');
                item.addClass('active');

                nome = item.find('.nome').html();
                img = item.find('.img').css('background-image');
                img = img.replace(/['"]+/g, '');
                price = item.find('.price').html();

                tipo = item.data('type');

                html = '<div class="text-info">' + nome + '</div>';

                if (item.hasClass('bg')) {
                    html += '<div class="item-img repeat"><div class="img" style="background-image: ' + img + ';"></div></div>';
                    html += '<div class="item-price">' + price + '</div>';
                } else {
                    html += '<div class="item-img"><div class="img" style="background-image: ' + img + ';"></div></div>';
                    html += '<div class="item-price">' + price + '</div>';
                }

                price_ids = item.find('#price-ids');
                price_esm = item.find('#price-esm');
                price_alt = item.find('#price-alt');
                gratis = item.find('b.free');

                html += '<center><b>Comprar item</b></center>';
                html += '<small class="fLeft" style="padding:7px;">Quantidade:</small>';

                if (item.hasClass('bg')) {
                    html += '<input id="store-qtd" class="form-control" type="text" placeholder="Quantidade" value="1" disabled>';
                } else {
                    html += '<input id="store-qtd" class="form-control" type="text" placeholder="Quantidade" value="1" onkeyup="UserHome.store.shop.calcPrice();" onkeydown="UserHome.store.shop.calcPrice();">';
                }

                html += '<small>Usando:</small><br>';
                html += '<div>';

                if (price_ids.length) {
                    html += '<div class="btn-eight" onclick="UserHome.store.shop.buy.send(' + id + ', \'' + tipo + '\', 1);">ProCash</div>';
                }

                if (price_esm.length) {
                    html += '<div class="btn-eight" onclick="UserHome.store.shop.buy.send(' + id + ', \'' + tipo + '\', 2);">Esmeraldas</div>';
                }

                if (price_alt.length) {
                    html += '<div class="btn-eight" onclick="UserHome.store.shop.buy.send(' + id + ', \'' + tipo + '\', 3);">' + price_alt.data("name") + '</div>';
                }

                if (gratis.length) {
                    html += '<div class="btn-eight" onclick="UserHome.store.shop.buy.send(' + id + ', \'' + tipo + '\', 4);">GRÁTIS!!</div>';
                }

                html += '</div>';

                $("#store-desc").html(html);
            },
            pIdsCurrent: 0,
            pEsmCurrent: 0,
            pAltCurrent: 0,
            calcPrice: function() {
                input = $("#store-qtd").val();
                item = $("#store-qtd").parent();

                if ($.isNumeric(input)) {
                    price_ids = item.find('#price-ids');
                    price_esm = item.find('#price-esm');
                    price_alt = item.find('#price-alt');

                    if (UserHome.store.shop.pIdsCurrent == 0) {
                        UserHome.store.shop.pIdsCurrent = price_ids.text();
                    }
                    if (UserHome.store.shop.pEsmCurrent == 0) {
                        UserHome.store.shop.pEsmCurrent = price_esm.text();
                    }
                    if (UserHome.store.shop.pAltCurrent == 0) {
                        UserHome.store.shop.pAltCurrent = price_alt.text();
                    }

                    if (price_ids.length) {
                        pIds = input * UserHome.store.shop.pIdsCurrent;
                        price_ids.text(pIds);
                    }

                    if (price_esm.length) {
                        pEsm = input * UserHome.store.shop.pEsmCurrent;
                        price_esm.text(pEsm);
                    }

                    if (price_alt.length) {
                        pAlt = input * UserHome.store.shop.pAltCurrent;
                        price_alt.text(pAlt);
                    }
                } else {
                    $("#store-qtd").val(input.slice(0, -1));
                }
            },
            buy: {
                send: function(id, tipo, moeda) {
                    if (confirm("Comprar este item?") == true) {
                        qtd = $("#store-qtd").val();

                        $.ajax({
                            url: '/a/user/home/store/shop/buy',
                            type: 'POST',
                            dataType: 'json',
                            data: {
                                'id': id,
                                'tipo': tipo,
                                'moeda': moeda,
                                'qtd': qtd
                            },
                        }).done(function(data) {
                            if (data.status == 'error') {
                                var message = "";

                                for (i = data.messages.length - 1; i >= 0; i--) {
                                    message += data.messages[i];

                                    if (i > 0) {
                                        message += '<br>';
                                    }
                                }

                                Alertbox({
                                    title: "Erro ao comprar item",
                                    content: message,
                                    type: 'error'
                                });
                            } else {
                                Alertbox({
                                    title: 'Comprado com sucesso!',
                                    content: "Item comprado com sucesso! Ele agora se encontra no seu inventário.",
                                    type: 'success'
                                });
                            }
                        });
                    }
                }
            }
        },
        open: function(id) {
            $.fancybox.close();

            $.ajax({
                url: '/a/user/home/store/open',
                type: 'POST',
                dataType: 'json',
                data: {
                    'id': id
                },
            }).done(function(data) {
                $.fancybox.open(data.html, {
                    openEffect: 'fade',
                    closeEffect: 'fade',
                    closeBtn: false,
                    padding: 10,
                    scrolling: 'no',
                    width: 650,
                    touch: false,
                    baseClass: "user-home-fancybox",
                    helpers: {
                        overlay: {
                            closeClick: false,
                            locked: true,
                            css: {
                                'background': 'rgba(0, 0, 0, 0.4)'
                            }
                        }
                    },
                    afterShow: function() {
                        stickersUsing = new Array();
                        widgetsUsing = new Array();

                        $("#user-home .item.sticker").each(function() {
                            id = $(this).attr('rel');
                            stickersUsing.push(id);
                        });

                        $("#user-home .item.widget").each(function() {
                            id = $(this).attr('rel');
                            widgetsUsing.push(id);
                        });

                        for (var i = 0; i < stickersUsing.length; i++) {
                            data = stickersUsing[i];

                            $("#inv-cat-1 #box-item-" + data).addClass('inactive').removeAttr('onclick');
                        }

                        for (var i = 0; i < widgetsUsing.length; i++) {
                            data = widgetsUsing[i];

                            $("#inv-cat-2 #box-item-" + data).addClass('inactive').removeAttr('onclick');
                        }

                        $("#inv-cat-3 #box-item-" + UserHome.dataBgID).addClass('inactive').removeAttr('onclick');
                    },
                    beforeShow: function() {
                        $("#hmUser-store .scroll-content").slimScroll({
                            height: '400px'
                        });
                        /*
                        this.wrap.draggable({
                            handle: ".top"
                        });
                        */
                    }
                });
            });
        }
    },
    items: {
        setTheme: function(id, tema, isNote) {
            isNote = isNote || false;

            if (isNote) {
                $("#sticker-" + id).removeClass(function(index, css) {
                    return (css.match(/(^|\s)theme-\S+/g) || []).join(' ');
                }).addClass('theme-' + tema);

                $("#sticker-" + id).find('.box-theme').removeClass('active');
                $("#sticker-" + id).find('.box-theme.th-' + tema).addClass('active');
            } else {
                $("#widget-" + id).removeClass(function(index, css) {
                    return (css.match(/(^|\s)theme-\S+/g) || []).join(' ');
                }).addClass('theme-' + tema);

                $("#widget-" + id).find('.box-theme').removeClass('active');
                $("#widget-" + id).find('.box-theme.th-' + tema).addClass('active');
            }
        },
        options: function(id, tipo) {
            item = $("#" + tipo + "-" + id);
            settings = item.find('.settings-box');

            if (settings.css('display') == 'none') {
                settings.fadeIn('slow');
            } else {
                settings.fadeOut('slow');
            }
        },
        remove: function(id, tipo) {
            item = $("#" + tipo + "-" + id);
            item.find('.remove');

            item.fadeOut('slow', function() {
                item.remove();
            });
        },
        removeAll: function(event) {
            $("#user-home .item").fadeOut('slow', function() {
                $("#user-home .item").remove();
            });

            UserHome.dataIndex = 1;
        },
        invert: {
            x: function(id, tipo) {
                item = $("#" + tipo + "-" + id);

                if (item.hasClass('inverted')) {
                    item.removeClass('inverted');
                } else {
                    item.addClass('inverted');
                }
            }
        }
    },
    widgets: {
        book: {
            show: function(userId, username) {
                var html = '';

                html += '<form class="form-book-widget" data-id="' + userId + '" data-username="' + username + '">';
                html += '<div class="form-group">';
                html += '<label>Mensagem</label>';
                html += '<textarea class="form-control" name="message" placeholder="Digite sua mensagem"></textarea>';
                html += '</div>';
                html += '<center><button type="submit" class="btn btn-primary btn-warning">Enviar</button></center>';
                html += '</form>';

                Alertbox({
                    title: "Envie uma mensagem",
                    content: html,
                    type: 'misc'
                });
            },
            send: function(e) {
                e.preventDefault();

                var form = $(this);

                if (form.hasClass('disabled')) {
                    return false;
                }

                content = form.find('textarea[name="message"]').val();
                var userId = form.data('id');
                var username = form.data('username');

                if (content == '') {
                    form.effect('shake', {
                        distance: 3
                    });
                } else {
                    form.addClass('disabled').animate({
                        'opacity': 0.5
                    });

                    $.ajax({
                        url: '/a/user/home/widgets/book/sendMessage',
                        type: 'POST',
                        dataType: 'json',
                        data: {
                            'message': content,
                            'id': userId
                        },
                    }).done(function(data) {
                        form.removeClass('disabled').animate({
                            'opacity': 1
                        });

                        if (data.status == 'error') {
                            var message = "";

                            for (i = data.messages.length - 1; i >= 0; i--) {
                                message += data.messages[i];

                                if (i > 0) {
                                    message += '<br>';
                                }
                            }

                            Alertbox({
                                title: "Erro ao enviar mensagem",
                                content: message,
                                type: 'error'
                            });
                        } else {
                            $.fancybox.close();

                            var html = '';

                            html += '<div class="box-message cf">';
                            html += '<a href="/home/' + username + '"><div class="img" style="background-image: url(https://www.habbo.com.br/habbo-imaging/avatarimage?img_format=gif&user=' + username + '&action=std&direction=2&head_direction=2&gesture=sml&size=s);"></div></a>';
                            html += '<div class="msg"><a href="/home/' + username + '"><b>' + username + '</b></a> agora:<br>' + content + '</div>';
                            html += '</div>';

                            $(".wid-book.wid-scroll").prepend(html);
                        }
                    });
                }
            }
        }
    },
    save: function() {
        dataWidgets = {};
        dataStickers = {};

        $("#user-home-save-button").attr('disabled', true);

        $("#user-home .item").each(function() {
            idAttr = $(this).attr('id');
            infos = idAttr.split('-');

            tipo = infos[0];
            id = parseInt(infos[1]);

            pTop = $(this).css('top').replace(/[^-\d\.]/g, '');
            pLeft = $(this).css('left').replace(/[^-\d\.]/g, '');
            pIndex = parseInt($(this).css('z-index'));
            idItem = $(this).attr('rel');

            if (tipo == 'widget') {
                classes = $(this).attr('class');
                tema = classes.match(/theme-[\w-]*\b/);

                dataWidgets[id] = [pTop, pLeft, pIndex, idItem, tema];
            }

            if (tipo == 'sticker') {
                if ($(this).hasClass('inverted')) {
                    inverted = 'true';
                } else {
                    inverted = 'false';
                }

                if ($(this).find('.home-note-textarea').length > 0) {
                    classes = $(this).attr('class');
                    tema = classes.match(/theme-[\w-]*\b/);
                    text = $("#sticker-" + id).find('textarea').val() || '';

                    dataStickers[id] = [pTop, pLeft, pIndex, idItem, inverted, tema, text];
                } else {
                    dataStickers[id] = [pTop, pLeft, pIndex, idItem, inverted];
                }
            }
        });

        $.ajax({
            url: '/a/user/home/save',
            type: 'POST',
            data: {
                'widgets': dataWidgets,
                'colantes': dataStickers,
                'id_fundo': parseInt(UserHome.dataBgID)
            },
        }).done(function(data) {
            UserHome.saved = true;

            Alertbox({
                title: "Home",
                content: 'Alterações salvas com sucesso!',
                type: 'success'
            });

            window.location.href = window.location.href;

            $("#user-home-save-button").attr('disabled', false);
        });
    },
    drag: function() {
        $("#user-home .item").draggable({
            containment: "#user-home",
            cancel: ".not-move",
            start: function() {
                if ($(this).css('z-index') != UserHome.dataIndex) {
                    newIndex = parseInt(UserHome.dataIndex) + 1;
                    $(this).css('z-index', newIndex);

                    UserHome.dataIndex = newIndex;
                }
            },
            stop: function() {
                UserHome.saved = false;
            }
        });

        $("#user-home .item").on('click', function(event) {
            newIndex = parseInt(UserHome.dataIndex) + 1;

            if ($(this).css('z-index') != UserHome.dataIndex) {
                $(this).css('z-index', newIndex);

                UserHome.dataIndex = newIndex;
                UserHome.saved = false;
            }
        }).find('.edit').click(function(e) {
            return false;
        });

        $("#user-home .item.sticker").each(function() {
            idAttr = $(this).attr('id');
            infos = idAttr.split('-');
            id = parseInt(infos[1]);

            if (id > UserHome.idLastSticker) {
                UserHome.idLastSticker = id;

                if ($(this).css('z-index') > UserHome.dataIndex) {
                    UserHome.dataIndex = parseInt($(this).css('z-index'));
                }
            }
        });

        $("#user-home .item.widget").each(function() {
            idAttr = $(this).attr('id');
            infos = idAttr.split('-');
            id = parseInt(infos[1]);

            if (id > UserHome.idLastWidget) {
                UserHome.idLastWidget = id;

                if ($(this).css('z-index') > UserHome.dataIndex) {
                    UserHome.dataIndex = parseInt($(this).css('z-index'));
                }
            }
        });
    },
    widStart: function() {
        $(".wid-scroll").each(function() {
            if ($(this).height() > 180) {
                $(this).slimScroll({
                    height: '200px'
                });
            }
        });
    },
    init: function() {
        if (UserHome.editing) {
            UserHome.drag();
        }

        $(document).on('submit', '.form-book-widget', UserHome.widgets.book.send);
    }
};

$(window).on("load", function(e) {
    UserHome.widStart();
});

window.onbeforeunload = function() {
    if (!UserHome.saved) {
        return "Deseja sair desta página sem salvar as alterações em sua Home? Elas serão perdidas e não poderão ser recuperadas.";
    }
};
